import { normalizeManualPlateNumber } from './manual-payment'

export const toSafeManualPaymentAmount = (value) => {
  const amount = Number(value)
  return Number.isFinite(amount) && amount >= 0 ? amount : 0
}

export const buildManualCheckPaymentBody = (params = {}) => ({
  plate_number: normalizeManualPlateNumber(
    params.plateNumber || params.plate_number
  ),
  building_id: params.buildingId || params.building_id
})

export const buildManualPayPaymentBody = (params = {}) => ({
  ...buildManualCheckPaymentBody(params),
  amount: toSafeManualPaymentAmount(params.amount)
})
